(() => {
  const initialize = () => {
    document.querySelectorAll('.d2-delivery').forEach(details => {
      if (details.dataset.ready) return;
      details.dataset.ready = 'true';
      const summary = details.querySelector('summary');
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !details.open) return;
        details.open = false;
        summary.focus();
        event.preventDefault();
      });
      document.addEventListener('click', event => {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

/* Compact Design 2 header messages. Append after the existing store controller. */
(() => {
  const controllers = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let suspended = false;

  const initialize = (scope = document) => {
    const groups = [...scope.querySelectorAll('[data-d2-messages]')];
    if (scope.matches?.('[data-d2-messages]')) groups.unshift(scope);
    groups.forEach(group => {
      if (group.dataset.ready === 'true') return;
      const viewport = group.querySelector('[data-d2-message-viewport]');
      const track = group.querySelector('[data-d2-message-track]');
      const toggle = group.querySelector('[data-d2-message-toggle]');
      const status = group.querySelector('[data-d2-message-status]');
      const slides = track ? [...track.querySelectorAll('[data-d2-message]')] : [];
      if (!viewport || !track || !toggle || slides.length < 2) return;

      const listeners = new AbortController();
      const listen = (target, type, handler, options = {}) => {
        target.addEventListener(type, handler, {...options, signal: listeners.signal});
      };
      const originalTransform = track.style.transform;
      const originalSlides = slides.map(slide => ({
        hidden: slide.getAttribute('aria-hidden'),
        inert: slide.hasAttribute('inert')
      }));
      const clone = slide => {
        const copy = slide.cloneNode(true);
        copy.removeAttribute('data-d2-message');
        copy.setAttribute('data-d2-message-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        return copy;
      };
      const leadingClone = clone(slides[slides.length - 1]);
      const trailingClone = clone(slides[0]);
      let width = viewport.clientWidth;
      let index = Math.min(slides.length - 1, Math.max(0, Math.round(viewport.scrollLeft / (width || 1))));
      let position = index + 1;
      let userPaused = reducedMotion.matches;
      let hovered = false;
      let focusPaused = false;
      let onscreen = !('IntersectionObserver' in window);
      let moving = false;
      let pointer = null;
      let autoplayTimer = 0;
      let settleTimer = 0;
      let suppressClick = false;
      let clickTimer = 0;
      let destroyed = false;

      const stopTimer = () => {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = 0;
      };
      const render = (offset = 0) => {
        track.style.transform = `translate3d(calc(${-position * 100}% + ${offset}px), 0, 0)`;
      };
      const reflect = () => {
        group.dataset.paused = String(userPaused);
        toggle.setAttribute('aria-label', userPaused ? group.dataset.playLabel : group.dataset.pauseLabel);
        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== index));
          slide.toggleAttribute('inert', slideIndex !== index);
        });
      };
      const announce = () => {
        if (!status) return;
        const count = (group.dataset.statusTemplate || '')
          .replaceAll('[current]', String(index + 1))
          .replaceAll('[total]', String(slides.length));
        status.textContent = `${count} ${slides[index].textContent.trim()}`.trim();
      };
      const schedule = () => {
        stopTimer();
        if (destroyed || suspended || userPaused || hovered || focusPaused || pointer || moving ||
            document.hidden || !onscreen || !width || !group.isConnected ||
            document.querySelector('.d2-delivery[open]')) return;
        autoplayTimer = window.setTimeout(() => {
          autoplayTimer = 0;
          if (!group.isConnected) { destroy(); return; }
          move(index + 1, false);
        }, 4000);
      };
      const settle = () => {
        window.clearTimeout(settleTimer);
        settleTimer = 0;
        moving = false;
        track.classList.remove('is-moving');
        position = index + 1;
        render();
        schedule();
      };
      const animate = () => {
        stopTimer();
        if (reducedMotion.matches) { settle(); return; }
        moving = true;
        track.classList.add('is-moving');
        render();
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settle, 420);
      };
      const pauseByUser = () => {
        userPaused = true;
        reflect();
        stopTimer();
      };
      const move = (next, manual) => {
        if (manual) pauseByUser();
        if (moving) return;
        const previous = index;
        index = (next + slides.length) % slides.length;
        position = next + 1;
        reflect();
        if (manual && previous !== index) announce();
        animate();
      };
      const releasePointer = () => {
        if (!pointer) return;
        const id = pointer.id;
        pointer = null;
        if (viewport.hasPointerCapture?.(id)) viewport.releasePointerCapture(id);
      };
      const cancelDrag = () => {
        releasePointer();
        settle();
      };
      const endPointer = (event, cancelled = false) => {
        if (!pointer || event.pointerId !== pointer.id) return;
        const gesture = pointer;
        releasePointer();
        if (!gesture.horizontal) { schedule(); return; }
        suppressClick = true;
        window.clearTimeout(clickTimer);
        clickTimer = window.setTimeout(() => { suppressClick = false; }, 350);
        const distance = Math.abs(gesture.dx);
        const flick = distance >= 18 && performance.now() - gesture.started <= 250;
        if (!cancelled && (distance >= Math.min(36, width * 0.22) || flick)) {
          move(index + (gesture.dx < 0 ? 1 : -1), true);
        } else {
          position = index + 1;
          animate();
        }
      };

      track.prepend(leadingClone);
      track.append(trailingClone);
      group.dataset.ready = 'true';
      viewport.scrollLeft = 0;
      toggle.hidden = false;
      render();
      reflect();

      listen(track, 'transitionend', event => {
        if (event.target === track && event.propertyName === 'transform' && moving) settle();
      });
      listen(viewport, 'pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || pointer ||
            event.target.closest('a, button, input, select, textarea')) return;
        if (moving) settle();
        stopTimer();
        pointer = {
          id: event.pointerId, x: event.clientX, y: event.clientY,
          dx: 0, horizontal: false, started: performance.now()
        };
      });
      listen(viewport, 'pointermove', event => {
        if (!pointer || pointer.id !== event.pointerId) return;
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        if (!pointer.horizontal) {
          if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) {
            releasePointer();
            schedule();
            return;
          }
          if (Math.abs(dx) < 6 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
          pointer.horizontal = true;
          pauseByUser();
          viewport.setPointerCapture?.(event.pointerId);
        }
        if (event.cancelable) event.preventDefault();
        pointer.dx = Math.max(-width, Math.min(width, dx));
        render(pointer.dx);
      }, {passive: false});
      listen(window, 'pointerup', event => endPointer(event));
      listen(window, 'pointercancel', event => endPointer(event, true));
      listen(viewport, 'lostpointercapture', event => {
        // Touch starts with implicit capture on the touched child. Its bubbled
        // loss during transfer to this viewport must not cancel the swipe.
        if (event.target === viewport) endPointer(event, true);
      });
      listen(viewport, 'click', event => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, {capture: true});
      listen(viewport, 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.target !== viewport) return;
        const targets = {ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: slides.length - 1};
        if (!(event.key in targets)) return;
        event.preventDefault();
        cancelDrag();
        move(targets[event.key], true);
      });
      listen(toggle, 'click', event => {
        event.stopPropagation();
        userPaused = !userPaused;
        reflect();
        schedule();
      });
      listen(group, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        hovered = true;
        schedule();
      });
      listen(group, 'pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        hovered = false;
        schedule();
      });
      listen(group, 'pointerdown', () => { focusPaused = false; schedule(); });
      listen(group, 'keydown', () => { focusPaused = true; schedule(); });
      listen(group, 'focusin', event => {
        focusPaused = event.target.matches(':focus-visible');
        schedule();
      });
      listen(group, 'focusout', event => {
        if (group.contains(event.relatedTarget)) return;
        focusPaused = false;
        schedule();
      });
      listen(document, 'visibilitychange', () => {
        if (document.hidden) cancelDrag();
        schedule();
      });
      listen(document, 'toggle', event => {
        if (event.target.matches?.('.d2-delivery')) schedule();
      }, {capture: true});
      const onMotionChange = () => {
        if (reducedMotion.matches) pauseByUser();
        cancelDrag();
      };
      reducedMotion.addEventListener('change', onMotionChange);

      const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        onscreen = entries[0].isIntersecting && entries[0].intersectionRatio > 0;
        if (!onscreen) cancelDrag();
        schedule();
      }) : null;
      intersection?.observe(group);
      if (!intersection) {
        const checkPosition = () => {
          const box = group.getBoundingClientRect();
          onscreen = box.bottom > 0 && box.top < window.innerHeight && box.right > 0 && box.left < window.innerWidth;
          schedule();
        };
        listen(window, 'scroll', checkPosition, {passive: true});
        checkPosition();
      }
      const measure = () => {
        const nextWidth = viewport.clientWidth;
        if (nextWidth === width) return;
        width = nextWidth;
        cancelDrag();
      };
      const resize = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
      if (resize) resize.observe(viewport);
      else listen(window, 'resize', measure, {passive: true});

      function destroy() {
        if (destroyed) return;
        destroyed = true;
        stopTimer();
        window.clearTimeout(settleTimer);
        window.clearTimeout(clickTimer);
        listeners.abort();
        releasePointer();
        intersection?.disconnect();
        resize?.disconnect();
        reducedMotion.removeEventListener('change', onMotionChange);
        leadingClone.remove();
        trailingClone.remove();
        track.classList.remove('is-moving');
        track.style.transform = originalTransform;
        slides.forEach((slide, slideIndex) => {
          const original = originalSlides[slideIndex];
          if (original.hidden === null) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', original.hidden);
          slide.toggleAttribute('inert', original.inert);
        });
        toggle.hidden = true;
        delete group.dataset.ready;
        delete group.dataset.paused;
        controllers.delete(group);
      }
      controllers.set(group, {destroy, resume: () => { measure(); schedule(); }, suspend: cancelDrag});
      schedule();
    });
  };

  initialize();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, group) => {
      if (event.target.contains(group)) controller.destroy();
    });
  });
  const removals = new MutationObserver(() => {
    controllers.forEach((controller, group) => { if (!group.isConnected) controller.destroy(); });
  });
  removals.observe(document.documentElement, {childList: true, subtree: true});
  window.addEventListener('pagehide', () => {
    suspended = true;
    controllers.forEach(controller => controller.suspend());
  });
  window.addEventListener('pageshow', () => {
    suspended = false;
    controllers.forEach(controller => controller.resume());
  });
})();
